import SimpleChecklistItem from "./SimpleChecklistItem";

export default class SimpleChecklistItemArticle extends SimpleChecklistItem{
    constructor(id, content_id, article){
        super(id, content_id);
        if(!article)
            throw "article is undefined for SimpleChecklistItemArticle";
        this.articleId = article.id;
        this.articleTitle = article.title;
    }
}